
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/CategoryListingPage",
      function () {
        return require("private-next-pages/CategoryListingPage.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/CategoryListingPage"])
      });
    }
  